module.exports = __webpack_public_path__ + "static/media/telegram.6b389b20.png";